module.exports = __webpack_public_path__ + "img/xbzp.b060fd6c.png";